/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getProductPresentationExtractor = (params) =>
  makeApiCall(`/dcr/agendas/product_presentation`, 'GET', params);
